
import React, { useState } from 'react';

export const Kontakti: React.FC = () => {
  const [submitted, setSubmitted] = useState(false);
  const [topic, setTopic] = useState('Ceļojuma plānošana');
  const [isFormSubmitting, setIsFormSubmitting] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsFormSubmitting(true);
    setTimeout(() => {
      setIsFormSubmitting(false);
      setSubmitted(true);
    }, 1000);
  };

  const topics = [
    'Ceļojuma plānošana',
    'Rezervāciju izmaiņas',
    'Citi jautājumi'
  ];

  return (
    <div className="bg-[#F8FAFC] min-h-screen py-20 px-4">
      {/* Page Title & Subheading */}
      <div className="max-w-[1400px] mx-auto mb-12">
        <h1 className="text-5xl md:text-7xl font-black text-brand-deep tracking-tighter">Sazinies ar mums</h1>
        <p className="text-xl md:text-2xl font-bold text-brand-deep/60 mt-4 leading-tight">Raksti mums – būsim priecīgi palīdzēt.</p>
        <div className="w-24 h-2 bg-brand-accent mt-8 rounded-full"></div>
      </div>

      <div className="max-w-[1400px] mx-auto bg-white rounded-xl overflow-hidden shadow-2xl flex flex-col lg:flex-row">
        
        {/* Left Side: Form */}
        <div className="flex-[1.5] p-8 md:p-16 relative">
          {!submitted ? (
            <form onSubmit={handleSubmit} className="space-y-12">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-10">
                <div className="space-y-1">
                  <label className="block text-[11px] font-black uppercase text-brand-deep/40 tracking-wider">Vārds</label>
                  <input 
                    required 
                    type="text" 
                    placeholder=" "
                    className="w-full border-b border-brand-deep/20 py-2 focus:border-brand-accent outline-none transition-colors font-bold text-brand-deep placeholder:text-brand-deep/20" 
                  />
                </div>
                <div className="space-y-1">
                  <label className="block text-[11px] font-black uppercase text-brand-deep/40 tracking-wider">Uzvārds</label>
                  <input 
                    required 
                    type="text" 
                    placeholder="Doe"
                    className="w-full border-b border-brand-deep/20 py-2 focus:border-brand-accent outline-none transition-colors font-bold text-brand-deep placeholder:text-brand-deep/20" 
                  />
                </div>
                <div className="space-y-1">
                  <label className="block text-[11px] font-black uppercase text-brand-deep/40 tracking-wider">Epasts</label>
                  <input 
                    required 
                    type="email" 
                    className="w-full border-b border-brand-deep/20 py-2 focus:border-brand-accent outline-none transition-colors font-bold text-brand-deep" 
                  />
                </div>
                <div className="space-y-1">
                  <label className="block text-[11px] font-black uppercase text-brand-deep/40 tracking-wider">Telefona Numurs</label>
                  <input 
                    required 
                    type="tel" 
                    placeholder="+1 012 3456 789"
                    className="w-full border-b border-brand-deep/20 py-2 focus:border-brand-accent outline-none transition-colors font-bold text-brand-deep" 
                  />
                </div>
              </div>

              <div className="space-y-6">
                <h3 className="text-sm font-black text-brand-deep uppercase tracking-wider">Izvēlēties sazināšanās tematu?</h3>
                {/* Changed flex-row to flex-wrap and removed overflow-x-auto for mobile visibility */}
                <div className="flex flex-wrap items-center gap-x-6 gap-y-4 md:gap-x-10">
                  {topics.map((t) => (
                    <label key={t} className="flex items-center gap-3 cursor-pointer group flex-shrink-0">
                      <div className="relative w-5 h-5 flex items-center justify-center">
                        <input 
                          type="radio" 
                          name="topic" 
                          value={t}
                          checked={topic === t}
                          onChange={() => setTopic(t)}
                          className="peer appearance-none w-5 h-5 border-2 border-brand-surface rounded-full checked:border-brand-accent transition-all cursor-pointer"
                        />
                        <div className="absolute w-2.5 h-2.5 bg-brand-accent rounded-full scale-0 peer-checked:scale-100 transition-transform"></div>
                      </div>
                      <span className={`text-[13px] font-bold transition-colors ${topic === t ? 'text-brand-deep' : 'text-brand-deep/40'}`}>
                        {t}
                      </span>
                    </label>
                  ))}
                </div>
              </div>

              <div className="space-y-3">
                <label className="block text-[11px] font-black uppercase text-brand-deep/40 tracking-wider">Ziņa</label>
                <input 
                  required 
                  placeholder="Raksti savu ziņu..."
                  className="w-full border-b border-brand-deep/20 py-2 focus:border-brand-accent outline-none transition-colors font-bold text-brand-deep placeholder:text-brand-deep/20" 
                />
              </div>

              <div className="flex justify-end pt-4">
                <button 
                  type="submit" 
                  disabled={isFormSubmitting}
                  className="bg-brand-accent text-white px-10 py-4 rounded-md font-black text-xs uppercase tracking-widest hover:bg-brand-accentHover transition-all shadow-xl shadow-orange-100/50 disabled:opacity-50"
                >
                  {isFormSubmitting ? <i className="fas fa-circle-notch fa-spin"></i> : 'Nosūtīt Ziņu'}
                </button>
              </div>

              <div className="absolute bottom-4 left-16 opacity-20 pointer-events-none">
                <svg width="200" height="100" viewBox="0 0 200 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10 90C40 30 120 10 160 50" stroke="#05073C" strokeWidth="1" strokeDasharray="4 4" />
                  <g transform="translate(155, 35) rotate(-15)">
                    <path d="M0 0L20 10L0 12L5 6L0 0Z" fill="#05073C" />
                  </g>
                </svg>
              </div>
            </form>
          ) : (
            <div className="h-full flex flex-col items-center justify-center text-center py-20 animate-fade-in">
              <div className="w-20 h-20 bg-brand-surface text-brand-accent rounded-full flex items-center justify-center mb-8 text-3xl shadow-inner">
                <i className="fas fa-check"></i>
              </div>
              <h2 className="text-4xl font-black mb-4 text-brand-deep tracking-tight">Ziņa nosūtīta!</h2>
              <p className="text-brand-deep/60 font-bold mb-10 max-w-xs">Mēs sazināsimies ar Jums tuvākajā 24 stundu laikā.</p>
              <button 
                onClick={() => setSubmitted(false)} 
                className="text-brand-accent font-black uppercase text-[10px] tracking-widest border-b-2 border-brand-accent pb-1"
              >
                Atgriezties
              </button>
            </div>
          )}
        </div>

        <div className="flex-1 bg-brand-deep p-12 lg:p-16 text-white relative overflow-hidden flex flex-col">
          <div className="absolute bottom-[-50px] right-[-50px] w-64 h-64 bg-white/5 rounded-full"></div>
          <div className="absolute bottom-10 right-10 w-48 h-48 bg-white/5 rounded-full"></div>
          
          <div className="relative z-10 flex-grow">
            <h2 className="text-4xl font-black mb-16 tracking-tight">Kontakti:</h2>
            
            <div className="space-y-12">
              <div className="flex items-center gap-6 group">
                <div className="w-12 h-12 flex items-center justify-center rounded-md bg-white/10 group-hover:bg-brand-accent transition-colors">
                  <i className="fas fa-phone-alt text-lg"></i>
                </div>
                <span className="font-bold text-lg tracking-tight hover:text-brand-accent transition-colors">+371 20000000</span>
              </div>
              <div className="flex items-center gap-6 group">
                <div className="w-12 h-12 flex items-center justify-center rounded-md bg-white/10 group-hover:bg-brand-accent transition-colors">
                  <i className="fas fa-envelope text-lg"></i>
                </div>
                <span className="font-bold text-lg tracking-tight hover:text-brand-accent transition-colors">info@lectravel.lv</span>
              </div>
              <div className="flex items-start gap-6 group">
                <div className="w-12 h-12 flex items-center justify-center rounded-md bg-white/10 flex-shrink-0 group-hover:bg-brand-accent transition-colors">
                  <i className="fas fa-map-marker-alt text-lg"></i>
                </div>
                <span className="font-bold text-lg leading-snug tracking-tight max-w-[220px]">
                  Brīvības iela 123, Rīga, LV-1012, Latvija
                </span>
              </div>
            </div>
          </div>

          <div className="relative z-10 pt-12">
            <a 
              href="https://instagram.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="w-10 h-10 bg-white text-brand-deep rounded-md flex items-center justify-center hover:bg-brand-accent hover:text-white transition-all shadow-lg"
            >
              <i className="fab fa-instagram text-xl"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
